import {Document, DocumentVersion} from 'notebook/documents/DocumentConstants';
import DocumentEvaluationUpdater from 'notebook/mediocre/DocumentEvaluationUpdater';
import {DocumentMapper, DocumentTraverser} from 'notebook/mediocre/DocumentTraversal';

export default class DocumentUpdater extends DocumentEvaluationUpdater<Document, DocumentVersion> {
  getDoc(item: Document): DocumentVersion {
    return item.documentVersion;
  }

  traverse(evalTraverser: DocumentTraverser, newDoc: DocumentVersion, oldDoc: DocumentVersion | null): void {
    evalTraverser.walkDocumentVersion(newDoc, oldDoc);
  }

  mapDoc(mapper: DocumentMapper, doc: DocumentVersion): DocumentVersion {
    return mapper.mapDocumentVersion(doc, null);
  }

  updatedRoot(root: Document, doc: DocumentVersion): Document {
    return {...root, documentVersion: doc};
  }
}
